import { Component, OnInit, computed, input, signal, viewChildren } from '@angular/core';
import { NgModel } from '@angular/forms';
import { T4 } from '@app/models/payroll/t4.model';
import { T4Service } from '@app/modules/payroll/services';
import { T4Notification } from '@app/modules/payroll/services/t4-notifications.service';
import { BaseForm } from '@forms/base.form';
import { T4Box } from '@models/payroll/t4-box.model';
import { map, mergeAll, tap } from 'rxjs/operators';

@Component({
    selector: 'app-t4-form',
    templateUrl: './t4.template.html',
})
export class T4Form extends BaseForm implements OnInit {
    fields = viewChildren<NgModel>('field');

    t4 = input.required<T4>();
    employeeNotifications = input<T4Notification>();

    box45?: string;
    t4Boxes = signal<T4Box[]>([]);
    /**
     * Computed array of booleans in the same order as t4Boxes, an index is true if the box has notifications
     */
    t4BoxNotifications = computed(
        () => this.t4Boxes()?.map(({ boxNumber }) => this.employeeNotifications()?.boxes.includes(boxNumber)) ?? []
    );

    isLoading = true;

    constructor(private t4Service: T4Service) {
        super();
    }

    ngOnInit(): void {
        // Pulls the numeric code value (1,2,3,4 or 5)
        // It can be null if code is not assigned
        this.box45 = this.t4().emprDntlBenRptCd[1]?.code?.toString();
        this.t4Service
            .getBoxes(this.t4())
            .pipe(
                map((groupedBoxes) => groupedBoxes.map(({ boxes }) => boxes)),
                mergeAll(), // Flattens groups since they don't exist for T4s
                tap(() => (this.isLoading = false))
            )
            .subscribe(this.t4Boxes.set);
    }
}
